module.exports = __webpack_public_path__ + "media/images/cart/route01-04cea1ca8010c5cd259a05c5e3248e2f.gif";